import React, { useState } from 'react';
import { moveScreens } from '../api/connectionRegistryApi';
import { apiErrorMessage } from '../utils/auditUser';
import { setPlacement } from '../utils/screenPlacement';
import { useCanManageSettings } from '../utils/screenAccess';
import { useToast } from '../utils/useToast';
import { useSupportingTools } from '../SupportingToolsContext';
import Switch from './Switch';
import Toast from './Toast';

// The "Make It Live" switch at the top right of an open Supporting Tools screen.
// Turning it on moves that screen to Supporting Tools Live straight away — the
// same move as the switch for it in Settings — and the screen drops out of this
// list, so the page falls back to its "pick a screen" state on its own. Never shown
// inside Live itself (moving back is done from Settings).
function MakeItLiveButton({ screen }) {
  const canManage = useCanManageSettings();
  const { variant } = useSupportingTools();
  const { toast, setToast, showToast } = useToast();
  const [busy, setBusy] = useState(false);

  if (!screen || !canManage || variant === 'live') return null;

  const handleChange = async (e) => {
    if (!e.target.checked || busy) return;
    setBusy(true);
    try {
      const res = await moveScreens([screen.key], 'live');
      setPlacement(res.live);
    } catch (err) {
      showToast('error', 'Update Failed', apiErrorMessage(err, `Could not move ${screen.label}.`), true);
      setBusy(false);
    }
  };

  return (
    <>
      <Toast toast={toast} onClose={() => setToast(null)} testId="make-it-live-toast" />
      <Switch
        checked={false}
        disabled={busy}
        onChange={handleChange}
        label="Make It Live"
        testId="make-it-live-switch"
      />
    </>
  );
}

export default MakeItLiveButton;
